import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { observable, action, toJS } from 'mobx';
import Form, { FormBody, SelectInput } from "../../Form";
// import LeafletMap from "../../LeafletMap";
import { getCenter } from "../../Map/getCenterLatLng";
// import { BASE_URL } from "../../../config";
// import Spinner from '../../Spinner';
import { Map, TileLayer, Marker, Popup } from 'react-leaflet';
import ImagePopup from './ImagePopup';
import L from 'leaflet';
import { imagePopupPosition } from '../../../libs/localStorage';
import ReactSpinner from 'react-spinner';

class ExtendedMarker extends Marker {
  // "Hijack" the component lifecycle.
  componentDidMount() {
    // Call the Marker class componentDidMount (to make sure everything behaves as normal)
    super.componentDidMount();

    // Access the marker element and open the popup.
    this.leafletElement.openPopup();
  }
}

@inject('stationStore', 'imageStore', 'imageSourceStore')
@observer
class GeoView extends Component {

  @observable selectedAlbum = 'All';
  @observable mapRef = null;

  fetchTimer;

  async componentWillMount() {
    const { stationStore, imageStore, imageSourceStore } = this.props;

    if (!imageSourceStore.albums.length) imageSourceStore.fetchAlbums();

    if (stationStore.items.length === 0) {
      await stationStore.fetchItems();
    }

    this.fetchImages();
    this.fetchTimer = setInterval(() => {
      this.fetchImages();
    }, 10 * 60 * 1000);
  }

  componentWillUnmount() {
    clearInterval(this.fetchTimer);
  }

  fetchImages = () => {
    this.props.imageStore.fetchLatestImages(this.selectedAlbum);
  }

  @action onChangeAlbum = e => {
    this.selectedAlbum = e.target.value;
    this.props.imageStore.fetchLatestImages(this.selectedAlbum);
  }

  getPopupBox = marker => {
    return (
      `<div id='station_marker-${marker.id}-popup' style='overflow: hidden; resize: both;'>
        <a href='/#/station/${marker.id}/images'style='font-size: 12px; font-weight: bold'>${marker.name}</a><br/>
        ${marker.timestamp}<br/>
        <div style="min-height: 150px; min-width: 200px; height: 100%; width: 100%; background-image: url('${marker.image}'); background-repeat: no-repeat; background-size: contain; overflow: auto;"/>
      </div>`
    );
  };

  makeDraggable = (map, popup, id) => {
    let pos = map.latLngToLayerPoint(popup._latlng);
    L.DomUtil.setPosition(popup._wrapper.parentNode, pos);
    const draggable = new L.Draggable(popup._container, popup._wrapper);
    draggable.enable();
    draggable.on('dragend', function () {
      let pos = map.layerPointToLatLng(this._newPos);
      imagePopupPosition.set(id, pos);
      popup.setLatLng(pos);
    });
  }

  render() {
    const { imageStore, imageSourceStore } = this.props;
    const { latestImages, latestImagesRefs } = imageStore;

    // const markers = latestImages.map(station => {
    //   const payload = {
    //     name: station.name,
    //     position: [station.latitude, station.longitude],
    //     id: `station_marker-${station.id}`,
    //     station_id: station.id,
    //     smallerIcon: `
    //               <svg viewBox="0 0 10 10" x="5" width="10" style="margin-left: -1px;margin-top: -2px;">
    //                 <circle cx="5" cy="5" r="4" stroke="white" stroke-width="0.5px" fill="green" />
    //               </svg>`,
    //     latitude: station.latitude,
    //     longitude: station.longitude,
    //     icon: `
    //       <svg id="${'ticket_marker-' + station.id}" viewBox="0 0 10 10" x="5" width="10" style="margin-left: -1px; margin-top: -2px;">
    //         <circle cx="5" cy="5" r="4" stroke="black" stroke-width="0.5px" fill="green" />
    //       </svg>
    //     `,
    //   }

    //   if (station.image[0] && station.image[0].source) {
    //     payload.draggable = this.getPopupBox({
    //       id: station.id,
    //       name: station.name,
    //       image: `${BASE_URL}/idaq-files/${station.image[0].source}`,
    //       timestamp: getDisplayDate(station.image[0].date_taken)
    //     });
    //   }

    //   return payload;
    // });

    let center = getCenter(latestImages);
    // console.log(toJS(this.imageRefs));

    return (
      <div>
        <Form>
          <FormBody>
            <SelectInput label='Album' options={[{ album_code: 'All' }, ...toJS(imageSourceStore.albums)]} defaultValue='All' value={this.selectedAlbum} onChange={this.onChangeAlbum} fields={{ label: 'album_code', value: 'album_code' }} />
          </FormBody>
        </Form>
        <Map center={[center.lat, center.lng]} zoom={7} ref={(c) => this.mapRef = c} fullscreenControl={true} zoomSnap={0.5} zoomDelta={0.5} wheelPxPerZoomLevel={200} >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {latestImages.length > 0 && latestImages.map(station => {
            let icon = `<svg id="${'ticket_marker-' + station.id}" viewBox="0 0 10 10" x="5" width="10" style="margin-left: -1px; margin-top: -2px;">
              <circle cx="5" cy="5" r="4" stroke="black" stroke-width="0.5px" fill="green" />
            </svg>`;
            return <ExtendedMarker position={[station.latitude, station.longitude]} icon={L.divIcon({ html: icon })} onclick={(e) => imagePopupPosition.remove(station.id)}>
              <Popup autoPan={false} autoClose={false} closeOnClick={false}
                ref={popup => {
                  setTimeout(() => {
                    let prevPos = imagePopupPosition.get(station.id);
                    if (!!popup) {
                      if (!!prevPos) popup.leafletElement.setLatLng(prevPos);
                      if (!!this.mapRef) this.makeDraggable(this.mapRef.leafletElement, popup.leafletElement, station.id)
                    }
                  }, 100)
                }}
              ><ImagePopup station={station} /></Popup>
            </ExtendedMarker>
          })}
          {imageStore.isLoading && !imageStore.latestImages.length && <div style={{
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            position: 'relative',
            zIndex: 1000,
          }}>
            <ReactSpinner />
          </div>}
        </Map>
        {/* <LeafletMap zoom={7.5} zoomSnap={0.5} zoomDelta={0.5}
          id='ImageGeoViewMap'
          markers={markers}
          center={getCenter(latestImages)}
          height='70vh'
          onMarkerClick={this.onMarkerClick}
          onMarkerOver={this.onMarkerOver}
        /> */}
      </div>
    );
  }
}

export default GeoView;


// WEBPACK FOOTER //
// ./src/components/Images/pages/GeoView.js